<template>
  <div class="privacy-policy">
    <h1>Contact Us</h1>
    <section>
      <p>
        If you have any questions, suggestions, or feedback, we'd love to hear
        from you! Please contact us using the following methods:
      </p>
      <p>Email:shengzhengzhao@gmail.com</p>
      <p>Company: HONG KONG BANFAAN TRADING CO., LIMITED</p>

      <!-- <h2>Contact Information</h2> -->
      <!-- <ul>
        <li><strong>Email:</strong>shengzhengzhao@gmail.com</li>
        <li><strong>Company:</strong> HONG KONG BANFAAN TRADING CO., LIMITED</li>
       
      </ul> -->
    </section>

    <!-- 更多部分... -->
  </div>
</template>

<script>
export default {
  name: "ContactUs",
};
</script>

<style scoped>
.privacy-policy {
  padding: 30px;
  font-family: Arial, sans-serif;
  max-width: 960px;
  margin: auto;
}

.privacy-policy h1,
.privacy-policy h2 {
  color: #333;
}

.privacy-policy p {
  line-height: 1.6;
  margin-bottom: 1em;
}

.privacy-policy ul {
  list-style-type: disc;
  margin-left: 20px;
}

.privacy-policy section {
  margin-bottom: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/views/pages/ContactUs.vue